import Vue from 'vue'
import App from './App'
import router from './router'
import firebase from 'firebase/app'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import Gallery from './components/Gallery.vue'

Vue.use(Vuetify, {
  theme: {
    primary: '#B388FF',
    secondary: '#424242',
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

Vue.config.productionTip = false

Vue.component('gallery', Gallery)

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  data () {
    return {
      userDetails: {}
    }
  },
  created () {
    const config = {
      apiKey: 'AIzaSyA0CGgFJMNmKXsiDzLsLFU_-B6Fa6DyJzo',
      authDomain: 'cakesbykarenrichardson.firebaseapp.com',
      databaseURL: 'https://cakesbykarenrichardson.firebaseio.com',
      projectId: 'cakesbykarenrichardson',
      storageBucket: 'cakesbykarenrichardson.appspot.com'
    }
    firebase.initializeApp(config)
    localStorage.removeItem('user')
    firebase.auth().onAuthStateChanged((user) => {
      if (user) {
        localStorage.setItem('user', JSON.stringify(user))
      }
    })
  },
  render: h => h(App)
})



// WEBPACK FOOTER //
// ./src/main.js